import { Component, effect, inject, untracked } from '@angular/core';
import { InvestmentService, TradeTransactionStore } from '@shared/data';

@Component({
  selector: 'app-balance-overdraft-dialog',
  standalone: false,
  templateUrl: './balance-overdraft-dialog.component.html',
  styleUrl: './balance-overdraft-dialog.component.scss'
})
export class BalanceOverdraftDialogComponent {
  balanceOverdraftDialogVisible = false;
  protected tradeTransactionStore = inject(TradeTransactionStore);
  private investmentService = inject(InvestmentService);
  private tradeTransaction = this.tradeTransactionStore.tradeTransaction;
  private hasBestandUeberziehung = this.tradeTransactionStore.hasBestandUeberziehung;

  constructor() {
    effect(() => {
      const showDialog = this.hasBestandUeberziehung();

      untracked(() => {
        this.balanceOverdraftDialogVisible = showDialog;
      });
    });
  }

  processExecuteAfterBalanceOverdraft() {
    const tradeTransaction = this.tradeTransaction();
    const linienEinhaltungOverride = tradeTransaction.linienEinhaltungOverride;
    this.investmentService.processExecute(tradeTransaction, linienEinhaltungOverride, true);

    this.tradeTransactionStore.updateHasBestandUeberziehung(false);
  }

  onCancel() {
    this.tradeTransactionStore.updateHasBestandUeberziehung(false);

    this.investmentService.resetStateForDialog();
  }
}
